import { SupportedLocale } from '@afterpay/types'
import { ConvergenceTFunction } from '../../model'
import { MAX_AMOUNT, MIN_AMOUNT } from './constants'

export const formatAmountForDisplay = (amount: number, locale?: SupportedLocale): string => {
  return amount.toLocaleString(locale)
}

export const getAmountError = (amount: string, t: ConvergenceTFunction, locale?: SupportedLocale): string | undefined => {
  const numericAmount = parseFloat(amount)
  const isValidFormat = /^\d+(\.\d{1,2})?$/.test(String(amount))

  if (amount === '' || isNaN(numericAmount) || !isValidFormat) {
    return t('adjustAmount:error.empty')
  }

  if (numericAmount < MIN_AMOUNT || numericAmount > MAX_AMOUNT) {
    return t('adjustAmount:error.outsideRange', { minimum: formatAmountForDisplay(MIN_AMOUNT, locale), maximum: formatAmountForDisplay(MAX_AMOUNT, locale) })
  }

  return undefined
}
